import React from "react";
import { Navigate } from "react-router-dom";
import { useParentAuth } from "../context/ParentAuthContext";

const RequireParent = ({ children }) => {
  const { user, loading } = useParentAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">Chargement...</div>;
  if (!user) return <Navigate to="/espace-famille/login" replace />;
  return children;
};

export default RequireParent;
